import { ISanityItemOption } from '@rbi-ctg/menu';

import { and, minLengthWithDefaultValue, some } from '..';

import { shouldDisplayItemOption } from './should-display-item-option';

export const shouldDisplayItemOptionGroup = and(
  minLengthWithDefaultValue<ISanityItemOption[]>(1, []),
  some(shouldDisplayItemOption)
);
